<template>
  <div id="change-psw" class="row">
    <div class="col-md-8 ml-auto mr-auto">
      <card type="user">
        <div class="card-header">
          <h5 class="title welcome-text">Change Password form</h5>
        </div>
        <div class="card-body">
          <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <a href="#">
              <img class="avatar" src="img/default.png" alt="...">
            </a>
          </div>
          <p></p>
          <form @submit.prevent>
            <div v-if="isGetCode" class="row">
              <div class="col-md-6">
                <base-input label="Code"
                            type="password"
                            placeholder="code"
                            v-model="form.code"
                            v-bind:error="errors.code"
                            v-bind:class="{ 'has-danger': !validation.code }">
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input label="Password"
                            type="password"
                            placeholder="Enter new password"
                            v-model="form.pwd"
                            v-bind:error="errors.pwd"
                            v-bind:class="{ 'has-danger': !validation.pwd }">
                </base-input>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-md-12">
                <base-input label="Email address"
                            type="email"
                            placeholder="Enter email"
                            v-model="form.email"
                            v-bind:error="errors.email"
                            v-bind:class="{ 'has-danger': !validation.email }">
                </base-input>
              </div>
            </div>
            <p>
              <br><br><br>
            </p>
            <div v-if="isGetCode" class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <button type="button" class="btn btn-default btn-block" v-on:click="isGetCode=false">Back</button>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <button type="button" class="btn btn-primary btn-block" v-on:click="sendNewPassword()">Complete</button>
                </div>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <button type="button" class="btn btn-default btn-block" v-on:click="authentication()">Back</button>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <button type="button" class="btn btn-primary btn-block" v-on:click="getCode()">Next step</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
    import {url} from "../../plugins/axios";
    import axios from "axios";
    import NotificationTemplate from "../Notifications/NotificationTemplate";

    export default {
      props: {
        activity: {
          type: Object,
          default: () => {
            return {};
          }
        }
      },
      name: "change-psw",
      data() {
        return {
          form:{
            email:'',
            code:'',
            pwd:'',
            conf_pwd:''
          },
          validation:{'email':true,'code':true, 'pwd':true, 'conf_pwd':true},
          errors:{code:'',email:'',pwd:''},
          isGetCode:false,
          responseCode:'',
          userId:0,
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        authentication: function () {
          this.activity.changePsw = false;
          this.activity.signIn = true;
        },
        validateEmail:function(value){
          this.validation.email = (value !== '');
          this.errors.email = (value === '') ? 'Email could not be empty' : '';
        },
        validateCode:function(value){
          this.validation.code = (value !== '');
          this.errors.code = (value === '') ? 'Wrong secret code' : '';
        },
        validatePassword:function(value){
          this.validation.pwd = (value !== '');
          this.errors.pwd = (value === '') ? 'Password could not be empty' : '';
        },
        getCode: function () {
          this.validateEmail(this.form.email);
          if(this.validation.email){
            axios
              .post(url + 'get-code/',
            {
              data: {"user_name":this.form.email}
            },
            {
              withCredentials:'include',
              crossDomain:true
            })
              .then((response) => {
                if (response.data.error === '') {
                  this.notifyVue('success', 'Code was sent to on email');
                  this.isGetCode = true;
                  this.userId = response.data.result;
                }
                else {
                  this.notifyVue('danger', response.data.error);
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
              });

          }
        },
        sendNewPassword: function () {
          this.validateCode(this.form.code);
          this.validatePassword(this.form.pwd);
          if(this.validation.pwd&&this.validation.code){
            axios
              .post(url + 'code-to-password/',
                {
                  data: {"code":this.form.code, "pwd":this.form.pwd, "user_id":this.userId}
                },
                {
                  withCredentials:'include',
                  crossDomain:true
                })
              .then((response) => {
                if (response.data.error === '') {
                  this.notifyVue('success', 'Code was change');
                  this.activity.changePsw = false;
                  this.activity.signIn = true;
                }
                else {
                  this.notifyVue('danger', response.data.error);
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
              });
          }
        }
      }
    }
</script>

<style scoped>
  .has-danger:after{
    top:45px;
  }
</style>
